var _circle, _circle2, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocked = function SvgLocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#D1B896"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Locked_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Locked_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: -15,
    y: -8.334,
    width: 50,
    height: 55,
    rx: 2,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 71.667,
    cy: 66.666,
    r: 20,
    stroke: "#000",
    strokeWidth: 6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    clipPath: "url(#Locked_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.239 54.258H27.022V33.107a15.108 15.108 0 0 1 30.217 0v21.151Zm-24.174-6.041h18.13v-15.11a9.064 9.064 0 1 0-18.129 0l-.001 15.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M57.239 37.083c0-.424-.266-.814-.684-.888a4.343 4.343 0 0 0-.706-.066h-3.654a1 1 0 0 0-1 1v10.088a1 1 0 0 1-1 1h-16.13a1 1 0 0 1-1-1V37.129a1 1 0 0 0-1-1h-3.654a4.318 4.318 0 0 0-.707.066c-.417.074-.683.463-.683.887v16.176a1 1 0 0 0 1 1h28.217a1 1 0 0 0 1-1V37.083Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.07 39.15H26.19c-1.21 0-2.19.981-2.19 2.19v22.816c0 1.21.98 2.19 2.19 2.19h31.88c1.21 0 2.19-.98 2.19-2.19V41.34c0-1.21-.98-2.19-2.19-2.19Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.481 52.566a4.35 4.35 0 1 0-7.73 2.722c.323.42.492.938.478 1.468v.646a2.9 2.9 0 1 0 5.8 0v-.648a2.389 2.389 0 0 1 .5-1.5c.615-.761.951-1.71.952-2.688Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Locked_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.239 51.258H24.022V30.107a15.108 15.108 0 0 1 30.217 0v21.151Zm-24.174-6.041h18.13v-15.11a9.064 9.064 0 1 0-18.129 0l-.001 15.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.239 34.083c0-.424-.266-.814-.684-.888a4.343 4.343 0 0 0-.706-.066h-3.654a1 1 0 0 0-1 1v10.088a1 1 0 0 1-1 1h-16.13a1 1 0 0 1-1-1V34.129a1 1 0 0 0-1-1h-3.654a4.318 4.318 0 0 0-.707.066c-.417.074-.683.463-.683.887v16.176a1 1 0 0 0 1 1h28.217a1 1 0 0 0 1-1V34.083Z",
    fill: "#A79378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.07 36.15H23.19c-1.21 0-2.19.981-2.19 2.19v22.816c0 1.21.98 2.19 2.19 2.19h31.88c1.21 0 2.19-.98 2.19-2.19V38.34c0-1.21-.98-2.19-2.19-2.19Z",
    fill: "#7D6E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.481 49.566a4.35 4.35 0 1 0-7.73 2.722c.323.42.492.938.478 1.468v.646a2.9 2.9 0 1 0 5.8 0v-.648a2.389 2.389 0 0 1 .5-1.5c.615-.761.951-1.71.952-2.688Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Locked_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(24 18)",
    d: "M0 0h36.26v48.346H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Locked_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(21 15)",
    d: "M0 0h36.26v48.346H0z"
  })))));
};
export default SvgLocked;